import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

// INTERFACE_SEND_EMAIL_REQUEST
interface SendDocumentEmailRequest {
    email: string;
    policy_number: string;
}

// INTERFACE_SUCCESS_RESPONSE
interface SendDocumentEmailSuccessResponse {
    message: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
    error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface SendDocumentEmailErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

// INTERFACE_RESULT
interface SendDocumentEmailResult {
    data: SendDocumentEmailSuccessResponse | SendDocumentEmailErrorResponse | GenericErrorResponse;
    status: number;
}

// SEND DOCUMENT EMAIL API
export const SendDocumentEmail = async (
    payload: SendDocumentEmailRequest,
    language: 'az' | 'en' = 'az'
): Promise<SendDocumentEmailResult> => {
    try {
        const response = await axiosInstance.post<SendDocumentEmailSuccessResponse>(
            'core/send-document-email',
            payload,
            {
                headers: {
                    'Accept-Language': language,
                }
            }
        );

        return {
            data: response.data,
            status: response.status
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1
        };
    }
};